module.exports = __webpack_public_path__ + "static/img/hulan.03fca90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/hulan.png
// module id = 05n7
// module chunks = 0